import * as TypeGraphQL from "type-graphql";
export var MarketSentimentScalarFieldEnum;
(function (MarketSentimentScalarFieldEnum) {
    MarketSentimentScalarFieldEnum["id"] = "id";
    MarketSentimentScalarFieldEnum["sentiment"] = "sentiment";
    MarketSentimentScalarFieldEnum["description"] = "description";
    MarketSentimentScalarFieldEnum["longDescription"] = "longDescription";
    MarketSentimentScalarFieldEnum["createdAt"] = "createdAt";
    MarketSentimentScalarFieldEnum["updatedAt"] = "updatedAt";
})(MarketSentimentScalarFieldEnum || (MarketSentimentScalarFieldEnum = {}));
TypeGraphQL.registerEnumType(MarketSentimentScalarFieldEnum, {
    name: "MarketSentimentScalarFieldEnum",
    description: undefined,
});
//# sourceMappingURL=MarketSentimentScalarFieldEnum.js.map